import type { Finding } from './bundleFindings'

export interface FindingsSummary {
  blocking: number
  suggestions: number
  worstSeverity: 'error' | 'warning' | null
}

/** Single source of truth for finding counts across the composer. */
export function summarizeFindings(findings: Finding[]): FindingsSummary {
  let blocking = 0
  let suggestions = 0
  for (const f of findings) {
    if (f.severity === 'error') blocking++
    else suggestions++
  }
  return {
    blocking,
    suggestions,
    worstSeverity: blocking > 0 ? 'error' : suggestions > 0 ? 'warning' : null,
  }
}
